import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {observable} from 'mobx';
import clsx from 'clsx';
import {Session} from './app/Session';
import {NotificationStore} from './app/notifications/NotificationStore';
import {NotificationObject} from './app/notifications/NotificationObject';
import Notification from './components/notifications/Notification';
import {SipStore} from './app/services/sip/SipStore';
import {BrowserType, checkCurrentBrowser} from "./app/utils/checkCurrentBrowser";
import {Variant} from "./components/notifications/Variant";

interface LoginProps {
    session?: Session;
    notifications?: NotificationStore;
    sipStore?: SipStore;
    onStackEvent: (event: SIPml.Stack.Event) => void;
    onError: (error: Error) => void;
}

class Login extends React.Component<LoginProps, {}> {
    @observable
    private form = {
        loading: false,
        username: '',
        password: '',
        error: ''
    }
    @observable currentBrowserType: BrowserType = BrowserType.UNKNOWN;

    public componentDidMount(): void {
        this.currentBrowserType = checkCurrentBrowser();
    }

    private async onSubmit(event: React.FormEvent): Promise<void> {
        this.form.loading = true;
        event.preventDefault();

        const {
            session,
            onStackEvent,
            onError,
            sipStore
        } = this.props;
        this.form.error = '';

        if (!this.form.username || !this.form.password) {
            this.form.error = 'Vul een gebruikersnaam en wachtwoord in';
        } else {
            const status = await session!.login(this.form.username, this.form.password);

            switch (status) {
                case 'success':
                    session!.loggedIn = true;
                    sipStore!.start(onStackEvent, onError);
                    break;
                case 'no_credentials':
                    this.form.error = 'Geen mogelijkheid tot bellen';
                        break;
                case 'incorrect':
                    this.form.error = 'Gebruikersnaam en/of wachtwoord is onjuist';
                    break;
                default:
                    this.form.error = 'Er is iets misgegaan';
            }
        }

        this.form.loading = false;
    }

    public render(): React.ReactNode {
        const { notifications } = this.props;

        return (
            (this.currentBrowserType === BrowserType.SAFARI || this.currentBrowserType === BrowserType.IE) ? (
                <Notification
                    variant={Variant.DANGER}
                    message={`Uw huidige browser (${this.currentBrowserType}) wordt niet ondersteund`}
                    id={'Browser not supported'}
                />
            ) : (
                <form className="login-form" method="POST" onSubmit={(event) => this.onSubmit(event)}>
                    <h2 className="softphone-header mt-0">Inloggen</h2>
                    {notifications!.notifications.map((notification: NotificationObject) => (
                        <Notification
                            variant={notification.variant}
                            message={notification.message}
                            id={notification.id}
                        />
                    )) }
                    {this.form.error && (
                        <div className="alert alert-danger">
                            {this.form.error}
                        </div>
                    )}
                    <div className="form-group">
                        <label className="form-label" htmlFor="username">Gebruikersnaam</label>
                        <input
                            type="text"
                            className="form-control"
                            id="username"
                            name="username"
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                this.form.username = event.target.value
                            }}
                            value={this.form.username}
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label"  htmlFor="password">Wachtwoord</label>
                        <input
                            type="password"
                            className="form-control"
                            id="password"
                            name="password"
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                this.form.password = event.target.value
                            }}
                            value={this.form.password}
                        />
                    </div>
                    <button
                        type="submit"
                        className={clsx(
                            'btn btn-primary block mr-auto',
                            this.form.loading && 'btn-loading'
                        )}
                        disabled={this.form.loading}
                    >
                        Inloggen
                    </button>
                </form>
            )
        );
    }
}

export default inject(
    'session',
    'notifications',
    'sipStore'
)(observer(Login));
